import React from 'react';
import { IconProps } from './props';

export const TextCursorIcon = (props: IconProps) => (
	<svg
		width="25"
		height="24"
		viewBox="0 0 25 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M11.5 18V6C11.5 4.67392 12.0272 3.40253 12.9648 2.46484C13.9025 1.52716 15.1739 1 16.5 1H17.5C18.0523 1 18.5 1.44772 18.5 2C18.5 2.55228 18.0523 3 17.5 3H16.5C15.7044 3 14.9415 3.3163 14.3789 3.87891C13.8163 4.44152 13.5 5.20435 13.5 6V18L13.5146 18.2969C13.5829 18.9835 13.8867 19.6289 14.3789 20.1211C14.9415 20.6837 15.7044 21 16.5 21H17.5C18.0523 21 18.5 21.4477 18.5 22C18.5 22.5523 18.0523 23 17.5 23H16.5C15.1739 23 13.9025 22.4728 12.9648 21.5352C12.0272 20.5975 11.5 19.3261 11.5 18Z"
			fill={props.fillColor ?? 'black'}
		/>
		<path
			d="M11.5 18V17C11.5 16.4477 11.9477 16 12.5 16C13.0523 16 13.5 16.4477 13.5 17V18L13.4941 18.248C13.4328 19.4838 12.9142 20.6561 12.0352 21.5352C11.0975 22.4728 9.82608 23 8.5 23H7.5C6.94772 23 6.5 22.5523 6.5 22C6.5 21.4477 6.94772 21 7.5 21H8.5C9.29565 21 10.0585 20.6837 10.6211 20.1211C11.1133 19.6289 11.4171 18.9835 11.4854 18.2969L11.5 18Z"
			fill={props.fillColor ?? 'black'}
		/>
		<path
			d="M11.5 7V6C11.5 5.20435 11.1837 4.44152 10.6211 3.87891C10.1289 3.38671 9.48351 3.08291 8.79688 3.01465L8.5 3H7.5C6.94772 3 6.5 2.55228 6.5 2C6.5 1.44772 6.94772 1 7.5 1H8.5L8.74805 1.00586C9.98382 1.06719 11.1561 1.58579 12.0352 2.46484C12.9728 3.40253 13.5 4.67392 13.5 6V7C13.5 7.55228 13.0523 8 12.5 8C11.9477 8 11.5 7.55228 11.5 7Z"
			fill={props.fillColor ?? 'black'}
		/>
	</svg>
);
